// import React, { useState, useEffect } from "react";
// import dayjs, { Dayjs } from "dayjs";
// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   Button,
//   TextField,
//   MenuItem,
//   CircularProgress,
//   useMediaQuery,
//   Theme,
//   Stack
// } from "@mui/material";
// import { Autocomplete } from "@mui/lab";
// import { DataGrid, GridColDef } from "@mui/x-data-grid";
// import { DatePicker } from "@mui/x-date-pickers";
// import {
//   generateReport,
//   fetchAllCustomers,
//   fetchProductCategories
// } from "../api/analyticsApi";
// import Grid from '@mui/material/GridLegacy';

// interface ReportData {
//   id: string;
//   created_at: string;
//   customer_id: string;
//   master_customer_id: string | null;
//   customer_name: string;
//   account_type: "Main" | "Subaccount";
//   product_name: string;
//   category: string;
//   quantity: number;
//   price: number;
//   total: number;
// }

// interface Filters {
//   startDate: Dayjs | null;
//   endDate: Dayjs | null;
//   customerId: string;
//   category: string;
// }

// const SalesReports = () => {
//   const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
//   const [filters, setFilters] = useState<Filters>({
//     startDate: dayjs().subtract(7, 'day'),
//     endDate: dayjs(),
//     customerId: "",
//     category: ""
//   });

//   const [customers, setCustomers] = useState<any[]>([]);
//   const [categories, setCategories] = useState<{ id: string, name: string }[]>([]);
//   const [reportData, setReportData] = useState<ReportData[]>([]);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);

//   const fetchReportData = async (reset = false) => {
//     setIsLoading(true);
//     setError(null);
//     try {
//       const params = {
//         startDate: filters.startDate?.format("YYYY-MM-DD"),
//         endDate: filters.endDate?.format("YYYY-MM-DD"),
//         customerId: filters.customerId,
//         category: filters.category,
//         page,
//         limit: 50
//       };

//       const data = await generateReport(params);
//       if (reset) {
//         setReportData(data);
//       } else {
//         setReportData(prev => [...prev, ...data]);
//       }

//       setHasMore(data.length === 50);
//     } catch (error) {
//       setError("Failed to load report data. Please check your filters.");
//       console.error("Error fetching report data:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const loadMore = () => {
//     if (hasMore && !isLoading) {
//       setPage(prev => prev + 1);
//     }
//   };

//   useEffect(() => {
//     const loadInitial = async () => {
//       try {
//         const [customerRes, categoryRes] = await Promise.all([
//           fetchAllCustomers(),
//           fetchProductCategories()
//         ]);
//         setCustomers(customerRes);
//         setCategories(categoryRes);
//         await fetchReportData(true);
//       } catch (err) {
//         console.error("Error loading initial data:", err);
//         setError("Failed to load initial data");
//       }
//     };
//     loadInitial();
//   }, []);

//   useEffect(() => {
//     setPage(1);
//     fetchReportData(true);
//   }, [filters]);

//   useEffect(() => {
//     if (page > 1) {
//       fetchReportData();
//     }
//   }, [page]);

//   const totalSales = reportData.reduce((acc, item) => acc + Number(item.total || 0), 0);
//   const formattedTotal = totalSales.toLocaleString("en-CA", {
//     style: "currency",
//     currency: "CAD"
//   });

//   const formatCurrency = (value: number) => {
//     return value.toLocaleString("en-CA", {
//       style: "currency",
//       currency: "CAD",
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     });
//   };

//   const MobileCardItem = ({ item }: { item: ReportData }) => (
//     <Card sx={{ mb: 1, boxShadow: 1 }}>
//       <CardContent sx={{ p: 2 }}>
//         <Stack spacing={1}>
//           <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//             <Typography variant="subtitle2">{new Date(item.created_at).toLocaleDateString()}</Typography>
//             <Typography variant="subtitle2" color="textSecondary">{item.category}</Typography>
//           </Box>
//           <Typography variant="body2" fontWeight="bold">{item.customer_name}</Typography>
//           <Typography variant="body2">{item.product_name}</Typography>
//           <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
//             <Typography variant="body2">Qty: {item.quantity}</Typography>
//             <Typography variant="body2">Price: {formatCurrency(item.price)}</Typography>
//             <Typography variant="body2" fontWeight="bold">
//               Total: {formatCurrency(item.total)}
//             </Typography>
//           </Box>
//         </Stack>
//       </CardContent>
//     </Card>
//   );

//   const columns: GridColDef[] = [
//     {
//       field: "created_at",
//       headerName: "Date",
//       flex: 1,
//       minWidth: 100,
//       valueFormatter: (value: any) => value ? new Date(value).toLocaleDateString() : "-"
//     },
//     { field: "customer_name", headerName: "Customer", flex: 1, minWidth: 120 },
//     {
//       field: "account_type",
//       headerName: "Type",
//       width: 120,
//       headerAlign: "center",
//       align: "center"
//     },
//     { field: "product_name", headerName: "Product", flex: 1, minWidth: 150 },
//     { field: "category", headerName: "Category", flex: 1, minWidth: 100 },
//     { field: "quantity", headerName: "Qty", width: 80, type: "number", align: "center", headerAlign: "center" },
//     {
//       field: "price",
//       headerName: "Price",
//       width: 100,
//       type: "number",
//       align: "right",
//       headerAlign: "right",
//       valueFormatter: (value: any) => value ? formatCurrency(Number(value)) : "-"
//     },
//     {
//       field: "total",
//       headerName: "Total",
//       width: 120,
//       type: "number",
//       align: "right",
//       headerAlign: "right",
//       valueFormatter: (value: any) => formatCurrency(Number(value))
//     }
//   ];

//   return (
//     <Box sx={{ p: isMobile ? 1 : 3, minHeight: "100vh", display: "flex", flexDirection: "column", gap: 2 }}>
//       <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
//           <Typography variant="h5" sx={{ fontWeight: 600, fontSize: isMobile ? "1.25rem" : "1.5rem" }}>
//             Sales Report
//           </Typography>
//           <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
//             Total Sales: {formattedTotal}
//           </Typography>
//         </Box>
//         <Button
//           variant="contained"
//           size="small"
//           onClick={() => {
//             const headers = columns.map(col => col.headerName).join(",");
//             const rows = reportData.map(row =>
//               columns.map(col => {
//                 const rawValue = (row as Record<string, any>)[col.field];
//                 const formatted = col.valueFormatter
//                   ? (col.valueFormatter as (value: any) => string)(rawValue)
//                   : rawValue ?? "";
//                 return `"${String(formatted).replace(/"/g, '""')}"`;
//               }).join(",")
//             ).join("\n");

//             const blob = new Blob([`${headers}\n${rows}`], { type: "text/csv;charset=utf-8;" });
//             const url = URL.createObjectURL(blob);
//             const link = document.createElement("a");
//             link.href = url;
//             link.download = `sales-report-${new Date().toISOString().slice(0, 10)}.csv`;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//           }}
//           disabled={reportData.length === 0 || isLoading}
//           sx={{ ml: "auto" }}
//         >
//           Export CSV
//         </Button>
//       </Box>

//       <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
//         <CardContent sx={{ p: isMobile ? 1 : 2 }}>
//           <Grid container spacing={1}>
//             <Grid item xs={12} sm={6} md={3}>
//               <DatePicker
//                 label="Start Date"
//                 value={filters.startDate}
//                 onChange={newValue => setFilters(prev => ({ ...prev, startDate: newValue }))}
//                 slotProps={{ textField: { size: "small", fullWidth: true } }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <DatePicker
//                 label="End Date"
//                 value={filters.endDate}
//                 onChange={newValue => setFilters(prev => ({ ...prev, endDate: newValue }))}
//                 slotProps={{ textField: { size: "small", fullWidth: true } }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Autocomplete
//                 options={customers}
//                 getOptionLabel={(option) => option.name || ""}
//                 size="small"
//                 onChange={(_, value) => setFilters(prev => ({ ...prev, customerId: value?.id || "" }))}
//                 renderInput={(params) => <TextField {...params} label="Customer" fullWidth />}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 select
//                 label="Category"
//                 size="small"
//                 value={filters.category}
//                 onChange={(e) => setFilters(prev => ({ ...prev, category: e.target.value }))}
//                 fullWidth
//               >
//                 <MenuItem value="">All</MenuItem>
//                 {categories.map(cat => (
//                   <MenuItem key={cat.id} value={cat.name}>{cat.name}</MenuItem>
//                 ))}
//               </TextField>
//             </Grid>
//           </Grid>
//           {error && (
//             <Typography color="error" variant="body2" sx={{ mt: 1 }}>
//               {error}
//             </Typography>
//           )}
//         </CardContent>
//       </Card>

//       <Box sx={{ flex: 1, overflowY: 'auto', mt: 2 }}>
//         {isMobile ? (
//           <Box sx={{ p: 1 }}>
//             {reportData.map(item => (
//               <MobileCardItem key={item.id} item={item} />
//             ))}
//             {hasMore && !isLoading && (
//               <Button fullWidth variant="outlined" onClick={loadMore} sx={{ mt: 1 }}>
//                 Load More
//               </Button>
//             )}
//           </Box>
//         ) : (
//           <DataGrid
//             rows={reportData}
//             columns={columns}
//             getRowId={(row: ReportData) => row.id}
//             density="standard"
//             autoHeight
//             disableRowSelectionOnClick
//             loading={isLoading}
//             sx={{
//               border: 'none',
//               '& .MuiDataGrid-columnHeaders': {
//                 backgroundColor: 'background.paper'
//               },
//               '& .MuiDataGrid-footerContainer': {
//                 borderTop: '1px solid',
//                 borderColor: 'divider',
//                 justifyContent: 'flex-end',
//                 pr: 2
//               }
//             }}
//             slots={{
//               footer: () => (
//                 <Box sx={{ p: 1 }}>
//                   <Typography variant="subtitle1">Total Sales: {formattedTotal}</Typography>
//                   {hasMore && !isLoading && (
//                     <Button size="small" variant="outlined" onClick={loadMore} sx={{ mt: 1 }}>
//                       Load More
//                     </Button>
//                   )}
//                 </Box>
//               )
//             }}
//           />
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default SalesReports;

import React, { useState, useEffect } from "react";
import dayjs, { Dayjs } from "dayjs";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  useMediaQuery,
  Theme,
  Stack
} from "@mui/material";
import { Autocomplete } from "@mui/lab";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers";
import {
  generateReport,
  fetchAllCustomers,
  fetchProductCategories
} from "../api/analyticsApi";
import Grid from '@mui/material/GridLegacy';

interface ReportData {
  id: string;
  created_at: string;
  customer_id: string;
  master_customer_id: string | null;
  customer_name: string;
  account_type: "Main" | "Subaccount";
  product_name: string;
  category: string;
  quantity: number;
  price: number;
  total: number;
  parentId?: string | null;
  hierarchy?: string[];
}

interface Filters {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  customerId: string;
  category: string;
}

const SalesReports = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [filters, setFilters] = useState<Filters>({
    startDate: null,
    endDate: null,
    customerId: "",
    category: ""
  });

  const [customers, setCustomers] = useState<any[]>([]);
  const [categories, setCategories] = useState<{id: string, name: string}[]>([]);
  const [reportData, setReportData] = useState<ReportData[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchReportData = async (reset = false) => {
    setIsLoading(true);
    setError(null);
    try {
      const params = {
        startDate: filters.startDate?.format('YYYY-MM-DD'),
        endDate: filters.endDate?.format('YYYY-MM-DD'),
        customerId: filters.customerId,
        category: filters.category,
        page,
        limit: 50
      };
      const data = await generateReport(params);
      if (reset) {
        setReportData(data);
      } else {
        setReportData(prev => [...prev, ...data]);
      }
      setHasMore(data.length === 50);
    } catch (error) {
      setError("Failed to load report data. Please check your filters.");
      console.error("Error fetching report data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const [customersData, categoriesData] = await Promise.all([
          fetchAllCustomers(),
          fetchProductCategories()
        ]);
        setCustomers(customersData);
        setCategories(categoriesData);
        await fetchReportData(true);
      } catch (err) {
        setError("Failed to load initial data");
        console.error("Error loading initial data:", err);
      }
    };
    loadInitialData();
  }, []);

  useEffect(() => {
    setPage(1);
    fetchReportData(true);
  }, [filters]);

  const loadMore = () => {
    if (hasMore && !isLoading) {
      setPage(prev => prev + 1);
    }
  };

  useEffect(() => {
    if (page > 1) fetchReportData();
  }, [page]);

  const totalSales = reportData.reduce((acc, item) => acc + Number(item.total || 0), 0);
  const formattedTotal = totalSales.toLocaleString('en-CA', {
    style: 'currency',
    currency: 'CAD'
  });

  const formatCurrency = (value: number) => {
    return value.toLocaleString('en-CA', {
      style: 'currency',
      currency: 'CAD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const MobileCardItem = ({ item }: { item: ReportData }) => (
    <Card sx={{ mb: 1, boxShadow: 1 }}>
      <CardContent sx={{ p: 2 }}>
        <Stack spacing={1}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="subtitle2">{new Date(item.created_at).toLocaleDateString()}</Typography>
            <Typography variant="subtitle2" color="textSecondary">
              {item.category}
            </Typography>
          </Box>
          <Typography variant="body2" fontWeight="bold">{item.customer_name}</Typography>
          <Typography variant="body2">{item.product_name}</Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
            <Typography variant="body2">Qty: {item.quantity}</Typography>
            <Typography variant="body2">Price: {formatCurrency(item.price)}</Typography>
            <Typography variant="body2" fontWeight="bold">
              Total: {formatCurrency(item.total)}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );

  const columns: GridColDef[] = [
    {
      field: "created_at",
      headerName: "Date",
      flex: 1,
      minWidth: 100,
      valueFormatter: (value: any) => value ? new Date(value).toLocaleDateString() : '-'
    },
    {
      field: "customer_name",
      headerName: "Customer",
      flex: 1,
      minWidth: 120
    },
    {
      field: "account_type",
      headerName: "Type",
      width: 120,
      headerAlign: "center",
      align: "center",
      valueFormatter: (value: any) => value || '-'
    },
    { field: "product_name", headerName: "Product", flex: 1, minWidth: 150 },
    { field: "category", headerName: "Category", flex: 1, minWidth: 100 },
    { field: "quantity", headerName: "Qty", width: 80, type: "number", headerAlign: 'center', align: 'center' },
    {
      field: "price",
      headerName: "Price",
      width: 100,
      type: "number",
      headerAlign: 'right',
      align: 'right',
      valueFormatter: (value: any) => value ? formatCurrency(Number(value)) : '-'
    },
    {
      field: "total",
      headerName: "Total",
      width: 120,
      type: "number",
      headerAlign: 'right',
      align: 'right',
      valueFormatter: (value: any) => formatCurrency(Number(value))
    }
  ];

  return (
    <Box sx={{ 
      p: isMobile ? 1 : 3, 
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      overflow: 'hidden'
    }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        gap: 2, 
        flexWrap: 'wrap'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="h5" sx={{ fontWeight: 600, fontSize: isMobile ? '1.25rem' : '1.5rem' }}>
            Sales Report
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
            Total Sales: {formattedTotal}
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            const headers = columns.map(col => col.headerName).join(",");
            const rows = reportData.map(row =>
              columns.map(col => {
                const rawValue = (row as Record<string, any>)[col.field];
                const formatted = col.valueFormatter
                  ? (col.valueFormatter as (value: any) => string)(rawValue)
                  : rawValue ?? "";
                return `"${String(formatted).replace(/"/g, '""')}"`;
              }).join(",")
            );
            
            // Add total sales row
            const totalRow = `"Total Sales","","","","","","","${formattedTotal.replace(/"/g, '""')}"`;
            
            const csvContent = `${headers}\n${rows.join("\n")}\n${totalRow}`;
            
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `sales-report-${new Date().toISOString().slice(0, 10)}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}
          disabled={reportData.length === 0 || isLoading}
          sx={{ ml: 'auto' }}
        >
          Export CSV
        </Button>
      </Box>

      <Card sx={{ boxShadow: 3, borderRadius: 2, flexShrink: 0 }}>
        <CardContent sx={{ p: isMobile ? 1 : 2 }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={3}>
              <DatePicker
                label="Start Date"
                value={filters.startDate}
                onChange={newValue => setFilters(prev => ({ ...prev, startDate: newValue }))}
                slotProps={{ textField: { size: 'small', fullWidth: true } }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DatePicker
                label="End Date"
                value={filters.endDate}
                onChange={newValue => setFilters(prev => ({ ...prev, endDate: newValue }))}
                slotProps={{ textField: { size: 'small', fullWidth: true } }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                options={customers}
                getOptionLabel={(option) => option.name || ""}
                size="small"
                onChange={(_, value) => setFilters(prev => ({ ...prev, customerId: value?.id || "" }))}
                renderInput={(params) => (
                  <TextField {...params} label="Customer" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                label="Category"
                size="small"
                value={filters.category}
                onChange={e => setFilters(prev => ({ ...prev, category: e.target.value }))}
                fullWidth
              >
                <MenuItem value="">All</MenuItem>
                {categories.map((cat) => (
                  <MenuItem key={cat.id} value={cat.name} sx={{ py: 0.5 }}>
                    {cat.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
        </CardContent>
      </Card>

      <Card sx={{ 
        flex: 1, 
        boxShadow: 3, 
        borderRadius: 2, 
        display: 'flex', 
        flexDirection: 'column',
        overflow: 'hidden'
      }}>
        <CardContent sx={{ 
          p: 0, 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          <Box sx={{ 
            position: 'relative', 
            flex: 1, 
            overflow: 'auto',
            minHeight: 200
          }}>
            {isLoading && (
              <Box sx={{
                position: 'absolute', 
                top: 0, 
                left: 0, 
                right: 0, 
                bottom: 0,
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                backgroundColor: 'rgba(255,255,255,0.8)', 
                zIndex: 1
              }}>
                <CircularProgress size={24} />
              </Box>
            )}

            {isMobile ? (
              <Box sx={{ p: 1 }}>
                {reportData.map((item) => (
                  <MobileCardItem key={item.id} item={item} />
                ))}
                {hasMore && !isLoading && (
                  <Button fullWidth variant="outlined" sx={{ mt: 1 }} onClick={loadMore}>Load More</Button>
                )}
              </Box>
            ) : (
              <DataGrid
                rows={reportData}
                columns={columns}
                getRowId={(row: ReportData) => row.id}
                density="standard"
                disableRowSelectionOnClick
                loading={isLoading}
                sx={{
                  border: 'none',
                  '& .MuiDataGrid-virtualScroller': {
                    overflow: 'auto'
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'background.paper'
                  },
                  '& .MuiDataGrid-footerContainer': {
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    justifyContent: 'flex-end',
                    pr: 2
                  }
                }}
                slots={{
                  footer: () => (
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle1">
                        Total Sales: {formattedTotal}
                      </Typography>
                      {hasMore && !isLoading && (
                        <Button size="small" variant="outlined" onClick={loadMore} sx={{ mt: 1 }}>
                          Load More
                        </Button>
                      )}
                    </Box>
                  )
                }}
              />
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SalesReports;